import React from 'react';

/**
 * CAPS status pill - light background / dark text pair per status variant.
 */
const PILL_STYLES = {
    green:     { background: 'rgba(85, 168, 106, 0.14)', color: '#3B7A4E' },
    red:       { background: 'rgba(244, 48, 60, 0.10)',  color: '#C2242F' },
    tan:       { background: 'rgba(199, 154, 99, 0.18)', color: '#8A6435' },
    scheduled: { background: 'rgba(140, 115, 89, 0.16)', color: '#6E5843' },
};

function StatusPill({ variant = 'red', label = '' }) {
    return (
        <span className="fou-status-pill" style={PILL_STYLES[variant] || PILL_STYLES.red}>
            {label}
        </span>
    );
}

export default StatusPill;
